import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cache = null;
let pending = null;
const subs = new Set();

export function setSectionsEnabled(v) {
  cache = v;
  subs.forEach((f) => f(v));
}

export function useSectionsEnabled() {
  const [on, setOn] = useState(cache ?? false);
  useEffect(() => {
    subs.add(setOn);
    if (cache === null) {
      pending = pending || api.get("/settings/sections").then((r) => setSectionsEnabled(!!r.data.enabled)).catch(() => setSectionsEnabled(false));
    } else {
      setOn(cache);
    }
    return () => { subs.delete(setOn); };
  }, []);
  return on;
}
